(() => {
  'use strict';
  const MARK = '_canalla_gift';
  const marked = item => item.properties?.[MARK] === 'rastar150';
  const subtotal = (cart, ids) => cart.items.reduce((sum, item) => sum + (!marked(item) && ids.includes(item.product_id) ? item.original_line_price : 0), 0);
  const free = (item, title) => item.quantity === 1 && item.final_line_price === 0 && item.line_level_discount_allocations?.some(a => a.discount_application?.title === title);
  globalThis.CanallaGiftRules = Object.freeze({ marked, subtotal, free });
  const root = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);
  let state, busy = false, pending = false, notice = '', selectedPreview = null;
  const opened = new Set(), expanded = new Set();
  const escape = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'es', { style:'currency', currency:state?.currency || 'EUR' }).format(value / 100);
  async function request(url, body) {
    const response = await nativeFetch(root + url, body ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)} : {cache:'no-store'});
    if (!response.ok) throw new Error('No se pudo actualizar el regalo. Revisa el carrito antes de pagar.');
    return response.json();
  }
  async function read() {
    const response = await nativeFetch(root + '?section_id=canalla-gift-state', {cache:'no-store'});
    if (!response.ok) throw new Error('No se pudo comprobar el regalo.');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const node = html.querySelector('[data-canalla-gift-state]');
    if (!node) throw new Error('No se pudo comprobar el regalo.');
    state = JSON.parse(node.textContent);
  }
  async function refreshSections() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      const ids = drawer.getSectionsToRender().map(s => s.id);
      const sections = await request('?sections=' + ids.join(','));
      for (const part of drawer.getSectionsToRender()) {
        const target = part.selector ? document.querySelector(part.selector) : document.getElementById(part.id);
        if (target && sections[part.id]) target.innerHTML = drawer.getSectionInnerHTML(sections[part.id],part.selector);
      }
      drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click',()=>drawer.close());
    }
    if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source:'canalla-gift'});
  }
  async function reconcile() {
    if (busy) { pending = true; return; }
    busy = true;
    try {
      await read();
      const gifts = state.cart.items.filter(marked);
      const eligible = state.enabled && state.currency === 'EUR' && subtotal(state.cart, state.rastar) >= 15000;
      const invalid = gifts.filter((item, index) => !eligible || index > 0 || !state.gifts.some(v => v.id === item.variant_id) || !free(item, state.title));
      if (invalid.length) {
        await request('cart/update.js', {updates:Object.fromEntries(invalid.map(i => [i.key,0]))});
        notice = 'Hemos retirado el regalo porque ya no cumple las condiciones o Shopify no confirma su gratuidad.';
        await read();
        await refreshSections();
      }
    } catch (error) { notice = error.message; }
    finally { busy = false; render(); if (pending) { pending = false; setTimeout(reconcile,100); } }
  }
  function render() {
    if (!state) return;
    state.cart.items.forEach((item,index) => {
      if (!marked(item)) return;
      for (const prefix of ['CartItem-','CartDrawer-Item-']) {
        const row = document.getElementById(prefix + (index + 1));
        if (row) row.style.display = state.enabled && free(item,state.title) ? 'none' : '';
      }
    });
    const amount = subtotal(state.cart, state.rastar), eligible = amount >= 15000 && state.currency === 'EUR';
    const preview = !state.enabled;
    const giftLine = state.cart.items.find(marked);
    const selected = preview ? state.gifts.find(v => v.id === selectedPreview) : giftLine && state.gifts.find(v => v.id === giftLine.variant_id);
    document.querySelectorAll('canalla-gift').forEach((host, index) => {
      const key = host.dataset.placement + index, pdp = host.dataset.placement === 'pdp';
      const thumbs = state.gifts.slice(0,3).map(g => `<img src="${escape(g.image)}" alt="" width="34" height="34">`).join('');
      let body = '';
      if (selected && (preview || eligible)) body = `<div class="cg-picked"><img src="${escape(selected.image)}" alt="" width="58" height="58"><div><strong>${preview ? 'Vista previa · ' : ''}Regalo · ${money(0)}</strong><p>${escape(selected.title)}</p><button class="cg-action" data-action="change">Cambiar</button> <button class="cg-action" data-action="remove">Quitar</button></div></div>`;
      else body = `<button class="cg-strip" data-action="toggle" aria-expanded="${opened.has(key)}"><span class="cg-thumbs" aria-hidden="true">${thumbs}</span><span class="cg-strip-copy">${pdp ? 'LEGO de regalo desde 150 € en Rastar' : eligible ? 'Tu LEGO de regalo incluido' : `Te faltan ${money(Math.max(0,15000-amount))} en Rastar`}<span class="cg-strip-link">${opened.has(key) ? 'Cerrar' : 'Ver regalos'} <span aria-hidden="true">${opened.has(key) ? '−' : '+'}</span></span></span></button>`;
      const show = opened.has(key);
      if (show) {
        body += `<div class="cg-grid">${state.gifts.slice(0,expanded.has(key)?50:3).map(g=>`<div class="cg-card"><img src="${escape(g.image)}" alt="${escape(g.title)}" width="100" height="100" loading="lazy"><span>${escape(g.title)}</span><button data-action="choose" data-variant="${g.id}" ${busy || (!preview && !eligible) ? 'disabled' : ''}>${preview ? 'Probar selección' : 'Elegir regalo'}</button></div>`).join('')}</div>`;
        if (state.gifts.length > 3 && !expanded.has(key)) body += '<button class="cg-action" data-action="all">Ver todos</button>';
        if (!state.gifts.length) body += '<p class="cg-note">No hay regalos disponibles ahora.</p>';
      }
      if (show) body += '<small class="cg-note">Un regalo por pedido. 150 € en Rastar antes de descuentos, sin envío.</small>';
      if (preview) body += '<small class="cg-note cg-preview">Vista previa · Promoción inactiva</small>';
      if (state.currency !== 'EUR') body += '<small class="cg-note">Promoción disponible en euros.</small>';
      host.innerHTML = `<div class="cg-box">${body}<div class="cg-status" role="status" aria-live="polite">${escape(notice)}</div></div>`;
      host.querySelectorAll('button').forEach(button => { button.type = 'button'; });
      host.dataset.key = key;
    });
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('canalla-gift button');
    if (!button) return;
    const key = button.closest('canalla-gift').dataset.key, action = button.dataset.action;
    if (action === 'toggle' || action === 'change') { opened.has(key) && action === 'toggle' ? opened.delete(key) : opened.add(key); render(); return; }
    if (action === 'all') { expanded.add(key); render(); return; }
    if (busy) return;
    if (!state.enabled) { selectedPreview = action === 'remove' ? null : Number(button.dataset.variant); try {sessionStorage.setItem('canalla-gift-preview',String(selectedPreview || ''));} catch {} opened.delete(key); render(); return; }
    busy = true; render();
    try {
      await read();
      const previous = state.cart.items.filter(marked);
      if (previous.length) await request('cart/update.js',{updates:Object.fromEntries(previous.map(i=>[i.key,0]))});
      if (action === 'choose') {
        const id = Number(button.dataset.variant);
        if (state.currency !== 'EUR' || subtotal(state.cart,state.rastar)<15000 || !state.gifts.some(v=>v.id===id)) throw new Error('El regalo ya no está disponible para este carrito.');
        await request('cart/add.js',{items:[{id,quantity:1,properties:{[MARK]:'rastar150'}}]});
        await read();
        const added = state.cart.items.find(marked);
        if (!added || !free(added,state.title)) {
          if (added) await request('cart/change.js',{id:added.key,quantity:0});
          throw new Error('Shopify no ha confirmado el regalo gratis. Lo hemos retirado para evitar un cobro.');
        }
      }
      notice = action === 'remove' ? 'Regalo retirado.' : 'Regalo añadido gratis.';
      opened.clear();
    } catch(error) { notice = error.message; }
    finally { busy = false; await reconcile(); await refreshSections(); }
  });
  let timer;
  const schedule = () => {clearTimeout(timer);timer=setTimeout(reconcile,160);};
  customElements.define('canalla-gift',class extends HTMLElement {connectedCallback(){schedule();}});
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, e => {if(e.source!=='canalla-gift')schedule();});
  window.addEventListener('pageshow',schedule);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});
  document.addEventListener('submit',async event=>{
    if (!state?.enabled || !state.cart.items.some(marked) || !event.submitter?.matches('[name="checkout"]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy) return;
    await reconcile();
    if (notice.startsWith('No se pudo')) return;
    if (!state.cart.items.every(i=>!marked(i)||free(i,state.title))) return;
    window.location.assign(root+'checkout');
  },true);
  try {selectedPreview=Number(sessionStorage.getItem('canalla-gift-preview'))||null;} catch {}
  schedule();
})();

